/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Walid Maaninou — Python Web Scraping & Automation",
  description:
    "Python web scraping & automation | data extraction & bots. End-to-end systems with full-stack and cloud capabilities. 150+ projects shipped since 2019.",
  og: {
    title: "Walid Maaninou — Python Web Scraping & Automation",
    type: "website",
    url: "http://walidmaaninou.com/",
  },
};

//Home Page
const greeting = {
  title: "Maaninou Walid",
  logo_name: "walidMaaninou",
  // nickname: "Hunter_Rovio",
  subTitle:
    "A passionate guy who always thrives to work on end to end projects which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink: "/resume.pdf",
  // portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  //githubProfile: "https://github.com/walidMaaninou",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/walidMaaninou",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/walid-maaninou-86a844102/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://www.youtube.com/channel/UC_amoXmmxSY9KusoDczDTXQ",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:maaninou.walid@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Upwork",
  //   link: "https://www.upwork.com/freelancers/walidmaaninou",
  //   fontAwesomeIcon: "upwork", // Reference https://fontawesome.com/icons/google?style=brands
  //   backgroundColor: "#fff", // Reference https://simpleicons.org/?q=gmail
  // },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "AI & Web Scraping",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
        "⚡ Developing efficient and effective web scrapings tools for a variety of applications - from online databases scraping to social media and online marketplaces (Amazon, facebook).",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Creating application backend in Node, Express, Django & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        // {
        //   skillName: "Sass",
        //   fontAwesomeClassname: "simple-icons:sass",
        //   style: {
        //     color: "#CC6699",
        //   },
        // },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        // {
        //   skillName: "Gatsby",
        //   fontAwesomeClassname: "simple-icons:gatsby",
        //   style: {
        //     color: "#663399",
        //   },
        // },
        // {
        //   skillName: "Flutter",
        //   fontAwesomeClassname: "simple-icons:flutter",
        //   style: {
        //     color: "#02569B",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "Blockchain Development",
      fileName: "DesignImg",
      skills: [
        "⚡ Development of platforms based on blockchain technologies such as nft marketplaces, dapps, bridges, cryptocurrency payment integration.",
      ],
      softwareSkills: [
        {
          skillName: "Solidity",
          fontAwesomeClassname: "simple-icons:solidity",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DBFB",
          },
        },
        {
          skillName: "Ethereum",
          fontAwesomeClassname: "simple-icons:ethereum",
          style: {
            color: "#3c3c3d",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:next-dot-js",
          style: {
            color: "black",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Coursera",
      iconifyClassname: "simple-icons:coursera",
      style: {
        color: "#0056D2",
      },
      // profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "IBM",
      iconifyClassname: "simple-icons:ibm",
      style: {
        color: "#006699",
      },
      // profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Microsoft",
      iconifyClassname: "simple-icons:microsoft",
      style: {
        color: "#1F8ACB",
      },
      // profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Udemy",
      iconifyClassname: "simple-icons:udemy",
      style: {
        color: "black",
      },
      // profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      // profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Hassania School of Public Works",
      subtitle: "Master's degree, Data Engineering",
      logo_path: "ehtp.png",
      alt_name: "EHTP",
      duration: "2019 - 2020",
      descriptions: [
        "⚡ I have studied all modules related to data science like Statistical Studies, Data Analysis, Data Visualisation, Big Data, AI, Databases (SQL/NoSQL) and BI.",
        "⚡ Apart from this, I have done courses on Deep Learning, Cloud Computing and Blockchain Development.",
      ],
      website_link: "http://www.ehtp.ac.ma/",
    },
    {
      title: "Hassan II University Aïn Chock Casablanca",
      subtitle: "Master's degree, Maths",
      logo_path: "fsac-bg.png",
      alt_name: "fsac",
      duration: "2016 - 2018",
      descriptions: [
        "⚡ The objective of this Master is to provide students with an advanced understanding of algebraic topology and geometry being the subject of current research in the fields of fundamental research in Mathematics, Mathematical Physics and robotic topology.",
      ],
      website_link: "https://fsac.univh2c.ma/",
    },
    {
      title: "Hassan II University Faculty of science Ben M'sik Casablanca",
      subtitle: "Bachelor's degree, Maths",
      logo_path: "fsbm.png",
      alt_name: "fsbm",
      duration: "2013 - 2016",
      descriptions: [
        "⚡ The objective of this Bachelor is to give students the necessary understanding of various mathematic fields such as algebra, calculus, geometry, statistics and probability.",
      ],
      website_link: "http://www.fsb.univh2c.ma/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Tensorflow Developer",
      subtitle: "- Laurence Moroney",
      logo_path: "tf.jpeg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/professional-cert/YPQN4CD369NT",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/KRB3X976VQFW",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Blockchain",
      subtitle: "- Bina Ramamurthy",
      logo_path: "ub.jpeg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/5D5FP9J5TWFK",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "IBM Big Data Engineer",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/548d9ded-1d20-4ab3-a7af-5fb69e07089c/public_url",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - PRESENT",
          location: "Hyderabad, Telangana",
          description:
            "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const dataaiHeader = {
  title: "AI & Web Scraping",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const dataai = {
  data: [
    {
      id: "browser-automation-2026",
      name: "Browser Automation Reliability & Recovery",
      createdAt: "2026-03-01T00:00:00Z",
      year: 2026,
      featured: true,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Playwright", skillName: "Playwright", iconifyClass: "logos-playwright" },
        { name: "Azure", skillName: "Azure", iconifyClass: "logos-microsoft-azure" },
      ],
      description:
        "Diagnosed and rebuilt a failing browser-automation suite running on Azure, restoring stable production runs and engaging on long-term maintenance for an automation agency's core pipelines.",
      url: "",
    },
    {
      id: "web3-ai-agent-2026",
      name: "Web3 AI Data Agent Framework",
      createdAt: "2026-02-15T00:00:00Z",
      year: 2026,
      featured: true,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Web3", skillName: "Web3", iconifyClass: "logos-ethereum" },
        { name: "LLM", skillName: "LLM", iconifyClass: "logos-openai-icon" },
      ],
      description:
        "Built and shipped AI-driven data agents for a web3 platform — connecting to live data sources, structuring their output, and exposing them as composable tools for the broader agent ecosystem.",
      url: "",
    },
    {
      id: "instagram-influencer-2026",
      name: "Instagram Influencer Data Extraction",
      createdAt: "2026-02-01T00:00:00Z",
      year: 2026,
      featured: true,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Instagram", skillName: "Instagram", iconifyClass: "logos-instagram" },
        { name: "S3", skillName: "S3", iconifyClass: "logos-aws-s3" },
      ],
      description:
        "Extracts structured profile data — bios, follower counts, verification status — from large Instagram accounts at scale (600k+ followers per target), with cost-aware account-by-account batching.",
      url: "",
    },
    {
      id: "classifieds-reconciliation-2026",
      name: "Classifieds Scraping & Data Reconciliation",
      createdAt: "2026-01-15T00:00:00Z",
      year: 2026,
      featured: true,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Playwright", skillName: "Playwright", iconifyClass: "logos-playwright" },
        { name: "CI", skillName: "CI", iconifyClass: "logos-github-actions" },
      ],
      description:
        "Scrapes Dubizzle and YallaMotor at scale, reconciles listings into a shared ontology, and ships with anti-bot bypass plus a CI-tested pipeline for reliable, repeatable runs.",
      url: "",
    },
    {
      id: "marketplace-social-2025",
      name: "Marketplace and Social Data Collection",
      createdAt: "2025-06-01T00:00:00Z",
      year: 2025,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
      ],
      description:
        "Collected product and social content data from multiple sources and delivered a clean dataset with over 150k rows for analysis and reporting.",
      url: "",
    },
    {
      id: "job-posting-2025",
      name: "Job Posting Automation at Scale",
      createdAt: "2025-04-01T00:00:00Z",
      year: 2025,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
      ],
      description:
        "Automated job listing tracking across major hiring platforms for over 100k companies and delivered updates directly to Google Sheets.",
      url: "",
    },
    {
      id: "shopify-pipeline-2024",
      name: "Multi-Store Shopify Data Pipeline",
      createdAt: "2024-09-01T00:00:00Z",
      year: 2024,
      featured: true,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "AWS Lambda", skillName: "AWS Lambda", iconifyClass: "logos-aws-lambda" },
        { name: "S3", skillName: "S3", iconifyClass: "logos-aws-s3" },
      ],
      description:
        "Engineered a Python scraper that extracts location, product, and stock data from multiple Shopify storefronts via undocumented endpoints, packaged for periodic execution on AWS Lambda with S3 output.",
      url: "",
    },
    {
      id: "location-price-2023",
      name: "Location-Based Price Monitoring",
      createdAt: "2023-08-01T00:00:00Z",
      year: 2023,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
      ],
      description:
        "Created a tool that compares product pricing by zip code and exports results in a simple report-ready format.",
      url: "",
    },
    {
      id: "carwash-cv-2022",
      name: "Car Wash Traffic Monitoring",
      createdAt: "2022-08-01T00:00:00Z",
      year: 2022,
      languages: [
        { name: "Pytorch", skillName: "Pytorch", iconifyClass: "logos-pytorch" },
        { name: "C++", skillName: "C++", iconifyClass: "logos-c-plusplus" },
        { name: "Raspberry Pi", skillName: "Raspberry Pi", iconifyClass: "logos-raspberrypi" },
      ],
      description:
        "Built an automated system to track car wash traffic and store results in the cloud, giving the business clear visibility on daily activity.",
      url: "",
    },
    {
      id: "legal-scrape-2022",
      name: "Legal Research Web Scraping",
      createdAt: "2022-04-01T00:00:00Z",
      year: 2022,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Regex", skillName: "Regex", iconifyClass: "logos-regex" },
      ],
      description:
        "Automated legal text collection from major legal sources to reduce manual research time and improve content coverage.",
      url: "",
    },
    {
      id: "fb-activity-2021",
      name: "Facebook Page Activity Tracking",
      createdAt: "2021-09-01T00:00:00Z",
      year: 2021,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
      ],
      description:
        "Captured posts, comments, reactions, and shares from a high-traffic Facebook page so the team could track engagement over time.",
      url: "",
    },
  ],
};

const bcHeader = {
  title: "Blockchain Development",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const bc = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Building an NFT marketplace (Opensea clone)",
      createdAt: "2020-03-06T16:26:54Z",
      languages: [
        {
          name: "Solidity",
          skillName: "Solidity",
          iconifyClass: "logos-solidity",
        },
        {
          name: "Hardhat",
          skillName: "Hardhat",
          iconifyClass: "logos-hardhat",
        },
        { name: "React", skillName: "React", iconifyClass: "logos-react" },
        {
          name: "Next.js",
          skillName: "Next.js",
          iconifyClass: "logos-next-js",
        },
      ],
      description:
        "I was responsible for writing the smart contract (Solidity) that manages the different actions such as: Create an NFT, List NFT for sell/auction, Buy NFT, Bid on an NFT, Fetching NFTs from the blockchain. I was also responsible for creating the web3 (React – JS) functions that interacts with the smart contract. ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   languages:[{"name": "Python", "skillName": "Python","iconifyClass": "logos-python"}],
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

const fullsHeader = {
  title: "Full Stack Development",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const fulls = {
  data: [
    {
      id: "trading-dashboard-2024",
      name: "Automated Trading Operations Dashboard",
      createdAt: "2024-04-01T00:00:00Z",
      year: 2024,
      languages: [
        { name: "Django", skillName: "Django", iconifyClass: "logos-django" },
        { name: "Binance", skillName: "Binance", iconifyClass: "logos-binance" },
        { name: "Bybit", skillName: "Bybit", iconifyClass: "logos-bybit" },
      ],
      description:
        "Built a full dashboard that automates market data monitoring and rule-based execution, helping users manage trading operations from one place.",
      url: "",
    },
    {
      id: "classified-ads-2023",
      name: "Classified Ads Monitoring Platform",
      createdAt: "2023-11-01T00:00:00Z",
      year: 2023,
      languages: [
        { name: "Django", skillName: "Django", iconifyClass: "logos-django" },
        { name: "Facebook", skillName: "Facebook", iconifyClass: "logos-facebook" },
      ],
      description:
        "Delivered a web app that tracks classified listings by location and filters, then updates a shared report automatically every hour.",
      url: "",
    },
    {
      id: "feedback-sentiment-2023",
      name: "Customer Feedback Sentiment Web App",
      createdAt: "2023-05-01T00:00:00Z",
      year: 2023,
      languages: [
        { name: "Python", skillName: "Python", iconifyClass: "logos-python" },
        { name: "Flask", skillName: "Flask", iconifyClass: "logos-flask" },
      ],
      description:
        "Built a web app that analyzes customer sentiment from text, files, and Facebook comments to give teams a fast view of audience mood.",
      url: "",
    },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   languages:[{"name": "Python", "skillName": "Python","iconifyClass": "logos-python"}],
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

const cloudHeader = {
  title: "Cloud Infra-Architecture",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const cloud = {
  data: [
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   languages:[{"name": "Python", "skillName": "Python","iconifyClass": "logos-python"}],
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   languages:[{"name": "Python", "skillName": "Python","iconifyClass": "logos-python"}],
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "walid-bg.png",
    description:
      "I’m a web scraping and automation expert with full-stack development capabilities.\nI’m available on LinkedIn and Gmail—feel free to reach out, and I’ll respond within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://ashutoshhathidara.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8320758513",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  dataaiHeader,
  dataai,
  bcHeader,
  bc,
  fullsHeader,
  fulls,
  cloudHeader,
  cloud,
  contactPageData,
};
